const axios = require('axios').default;
console.log(process.env.NODE_ENV)
console.log(process.env)
const host = (location.host).split(":");
let baseUrl;
let baseUrlMain;
let production  = true;


baseUrl = production == false ? "http://"+host[0]+":8000/api" : "https://apiincentive.commsk.dev/api";
baseUrlMain = production == false ? "http://"+host[0]+":8000" : "https://apiincentive.commsk.dev/" ;



const instance = axios.create({
    baseURL: baseUrl,
    timeout: 10000,
    headers: {
        'X-Custom-Header': 'foobar',
        'content-type': 'application/json',
        'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
        'token':localStorage.getItem("token")
    }
});




const API = {
    Register: '/auth/register',
    Login: '/auth/login',
    User: '/user',
    Employee: '/employee',
    NCP: '/ncp',
    NG: '/ng',
    Lead: '/lead',
    EmployeeAttendance: '/employee_attendance',
}





export {API,instance,baseUrl,baseUrlMain};
